import request from '@/utils/requests.js'

// Patient API Services
export const patientService = {
  // Patient Management
  async createPatient(patientData) {
    return request({
      url: '/patients/',
      method: 'post',
      data: patientData
    })
  },

  async listPatients(params = {}) {
    return request({
      url: '/patients/',
      method: 'get',
      params
    })
  },

  async getPatientById(patientId) {
    return request({
      url: `/patients/${patientId}`,
      method: 'get'
    })
  },

  async updatePatient(patientId, patientData) {
    return request({
      url: `/patients/${patientId}`,
      method: 'put',
      data: patientData
    })
  },

  async searchPatients(searchTerm) {
    return request({
      url: '/patients/search',
      method: 'get',
      params: { q: searchTerm }
    })
  },

  async getPatientByCpf(cpf) {
    return request({
      url: `/patients/cpf/${cpf}`,
      method: 'get'
    })
  },

  async updatePatientCpf(patientId, cpfData) {
    return request({
      url: `/patients/${patientId}/cpf`,
      method: 'patch',
      data: cpfData
    })
  },

  // Patient Personal Views
  async getMyExams() {
    return request({
      url: '/patient/my-exams',
      method: 'get'
    })
  },

  async getMyReports() {
    return request({
      url: '/patient/my-reports',
      method: 'get'
    })
  },

  // Dashboard metrics for patients
  getDashboardData() {
    return request({
      url: '/patient/dashboard',
      method: 'get'
    });
  },

  getPatientInfo() {
    return request({
      url: '/patient/info',
      method: 'get'
    });
  },

  getExamHistory(params = {}) {
    return request({
      url: '/patient/exams',
      method: 'get',
      params
    });
  },

  getUpcomingExams() {
    return request({
      url: '/patient/exams/upcoming',
      method: 'get'
    });
  },

  getReports() {
    return request({
      url: '/patient/reports',
      method: 'get'
    });
  },

  downloadReport(reportId) {
    return request({
      url: `/patient/reports/${reportId}/download`,
      method: 'get',
      responseType: 'blob'
    });
  },

  exportHistory() {
    return request({
      url: '/patient/history/export',
      method: 'get',
      responseType: 'blob'
    });
  },

  scheduleExam(examData) {
    return request({
      url: '/patient/exams/schedule',
      method: 'post',
      data: examData
    });
  },

  updateProfile(profileData) {
    return request({
      url: '/patient/profile',
      method: 'put',
      data: profileData
    });
  },
}
